/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Benefits_Item2Inputs */

const ja_playdata_home_benefits_item2 = /** @type {(inputs: Playdata_Home_Benefits_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競合イベントの視聴状況を把握したい`)
};

const en_playdata_home_benefits_item2 = /** @type {(inputs: Playdata_Home_Benefits_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to know about the viewership of my competitors' events`)
};

/**
* | output |
* | --- |
* | "I want to know about the viewership of my competitors' events" |
*
* @param {Playdata_Home_Benefits_Item2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_benefits_item2 = /** @type {((inputs?: Playdata_Home_Benefits_Item2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Benefits_Item2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_benefits_item2(inputs)
	return en_playdata_home_benefits_item2(inputs)
});